import React from "react";

const Icons = () => {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: "absolute" }}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <g id="blob-1" transform="translate(-100,-100)">
          <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
          <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
        </g>
        <g id="blob-2" transform="translate(100,-100) scale(-1,1)">
          <path d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z" />
          <path d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z" />
        </g>

        <symbol id="big-42" viewBox="0 0 200 160">
          <path
            fill="currentColor"
            d="M89,150H110V135H120V112H110V60H92L46,140V154H89ZM75,120l21-37V120Z"
          />
          <path
            fill="currentColor"
            d="M153,128v-.4l16-17c14-14.5,16.5-23.5,16.5-35.5,0-19.5-16-31.5-34-31.5s-29.5,9-35.5,20l17.5,12.5c4.5-6.5,10-9.5,16-9.5a11,11,0,0,1,11,11.3c0,7.5-4.5,14-13,22.7L120,135l.3,16h69V128Z"
          />
        </symbol>

        <symbol id="icon-fire" viewBox="0 0 32 32">
          <path
            fill="#FF645E"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M16 3 C 17 6 19 8 19 11 C 19 13 17.5 14 16.5 14 C 16 12.5 16.5 11 17 10 C 14 11 13 14 13 16 C 13 17.5 14 18.5 14 19 C 12.5 18 11.5 16.5 11 15 C 9.5 17.5 9 20 9 22 C 9 26 12 29 16 29 C 21 29 24 26 24 22 C 24 18 22 15.5 20.5 13 C 19.5 11 18.5 9 18 7 C 17.5 5 16.5 4 16 3 Z"
          />
          <path
            fill="#F3EC7A"
            stroke="#2E2437"
            strokeWidth="1.2"
            strokeLinejoin="round"
            d="M16 17 C 13.5 19 12.5 21 12.5 23 C 12.5 25.5 14 27 16 27 C 18 27 19.5 25.5 19.5 23.5 C 19.5 22 18.5 20 17 18.5 C 16.5 18 16 17.5 16 17 Z"
          />
        </symbol>

        <symbol id="icon-trophy" viewBox="0 0 32 32">
          <path
            fill="#F5B041"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M10 5 H22 V12 a6 6 0 0 1 -12 0 Z"
          />
          <path
            fill="none"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10 7 H6 V10 a3 3 0 0 0 4 3 M22 7 H26 V10 a3 3 0 0 1 -4 3"
          />
          <path
            fill="#C4841D"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M13 19 H19 V21 a1.5 1.5 0 0 1 -1.5 1.5 H14.5 a1.5 1.5 0 0 1 -1.5 -1.5 Z"
          />
          <rect
            x="11"
            y="24"
            width="10"
            height="2.5"
            rx=".5"
            fill="#C4841D"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <path
            fill="#F3EC7A"
            stroke="none"
            d="M15 7.5 L15.7 9 L17 9 L16 10 L16.5 11.5 L15 10.5 L13.5 11.5 L14 10 L13 9 L14.3 9 Z"
          />
        </symbol>

        <symbol id="icon-globe" viewBox="0 0 64 64">
          <circle
            cx="32"
            cy="32"
            r="28"
            fill="#E8EBFF"
            stroke="#2E2437"
            strokeWidth="2"
          />
          <ellipse
            cx="32"
            cy="32"
            rx="28"
            ry="11"
            fill="none"
            stroke="#2E2437"
            strokeWidth="1.5"
            opacity=".7"
          />
          <ellipse
            cx="32"
            cy="32"
            rx="14"
            ry="28"
            fill="none"
            stroke="#2E2437"
            strokeWidth="1.5"
            opacity=".7"
          />
          <path
            fill="#233dff"
            opacity=".55"
            d="M14 22 Q 22 18 30 22 Q 38 24 44 20 Q 50 24 48 30 Q 42 36 36 32 Q 28 38 20 32 Q 14 28 14 22 Z"
          />
          <path
            fill="#233dff"
            opacity=".55"
            d="M22 44 Q 30 40 38 44 Q 46 46 50 42 Q 50 48 46 50 Q 38 52 32 48 Q 24 50 22 44 Z"
          />
        </symbol>

        <symbol id="icon-flag-uk" viewBox="0 0 60 36">
          <rect width="60" height="36" fill="#012169" />
          <path d="M0,0 L60,36 M60,0 L0,36" stroke="#fff" strokeWidth="6" />
          <path d="M0,0 L60,36 M60,0 L0,36" stroke="#C8102E" strokeWidth="3" />
          <path d="M30,0 V36 M0,18 H60" stroke="#fff" strokeWidth="10" />
          <path d="M30,0 V36 M0,18 H60" stroke="#C8102E" strokeWidth="5" />
        </symbol>

        <symbol id="icon-badge" viewBox="0 0 32 32">
          <path
            fill="#FFA5BC"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M11 16 L8 28 L13 25 L16 27 L19 25 L24 28 L21 16 Z"
          />
          <circle
            cx="16"
            cy="12"
            r="8"
            fill="#F5B041"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <circle
            cx="16"
            cy="12"
            r="4.5"
            fill="#F3EC7A"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <path
            fill="#C4841D"
            d="M16 8 L17 11 L20 11 L17.5 13 L18.5 16 L16 14 L13.5 16 L14.5 13 L12 11 L15 11 Z"
          />
        </symbol>

        <symbol id="icon-cert" viewBox="0 0 32 32">
          <rect
            x="4"
            y="6"
            width="22"
            height="16"
            rx="1.5"
            fill="#F5F0E1"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <line
            x1="8"
            y1="11"
            x2="22"
            y2="11"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <line
            x1="8"
            y1="14.5"
            x2="18"
            y2="14.5"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <line
            x1="8"
            y1="18"
            x2="16"
            y2="18"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <circle
            cx="23.5"
            cy="18.5"
            r="3.5"
            fill="#F5B041"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <path
            d="M22 21 L20.5 27 L23.5 25.2 L26.5 27 L25 21"
            fill="#FF645E"
            stroke="#2E2437"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </symbol>

        <symbol id="icon-bulb" viewBox="0 0 32 32">
          <path
            fill="#F3EC7A"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M16 4 a8 8 0 0 0 -5 14.5 V22 h10 V18.5 A 8 8 0 0 0 16 4 Z"
          />
          <line
            x1="13"
            y1="22"
            x2="19"
            y2="22"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <rect x="13" y="23.5" width="6" height="2" rx="1" fill="#2E2437" />
          <rect x="13.5" y="26" width="5" height="1.8" rx=".9" fill="#2E2437" />
          <line
            x1="14"
            y1="29"
            x2="18"
            y2="29"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            fill="none"
            stroke="#C4841D"
            strokeWidth="1.2"
            strokeLinecap="round"
            d="M13.5 15 L15.5 11 L16.5 13.5 L18.5 10"
          />
          <path
            fill="#FF645E"
            d="M4 6 l1 -2 l1 2 l2 1 l-2 1 l-1 2 l-1 -2 l-2 -1 z"
          />
          <path
            fill="#233dff"
            d="M26 24 l.7 -1.5 l.7 1.5 l1.5 .7 l-1.5 .7 l-.7 1.5 l-.7 -1.5 l-1.5 -.7 z"
          />
        </symbol>

        <symbol id="icon-crown" viewBox="0 0 32 32">
          <path
            fill="#F5B041"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M4 11 L8 22 H24 L28 11 L22 16 L16 7 L10 16 Z"
          />
          <circle
            cx="8"
            cy="11"
            r="2"
            fill="#FF645E"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <circle
            cx="16"
            cy="7"
            r="2"
            fill="#FF645E"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <circle
            cx="24"
            cy="11"
            r="2"
            fill="#FF645E"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
          <rect
            x="6"
            y="22"
            width="20"
            height="3"
            rx=".8"
            fill="#C4841D"
            stroke="#2E2437"
            strokeWidth="1.2"
          />
        </symbol>

        <symbol id="icon-community" viewBox="0 0 32 32">
          <circle
            cx="11"
            cy="11"
            r="4"
            fill="#B798F2"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <circle
            cx="21"
            cy="11"
            r="4"
            fill="#FFA5BC"
            stroke="#2E2437"
            strokeWidth="1.5"
          />
          <path
            fill="#B798F2"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M3 25 c 0 -4 4 -7 8 -7 s 8 3 8 7 V 27 H 3 Z"
          />
          <path
            fill="#FFA5BC"
            stroke="#2E2437"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M13 25 c 0 -4 4 -7 8 -7 s 8 3 8 7 V 27 H 13 Z"
          />
        </symbol>

        <symbol id="icon-bell" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2v1h16v-1l-2-2z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            d="M10 21a2 2 0 0 0 4 0"
          />
        </symbol>

        <symbol id="icon-cog" viewBox="0 0 24 24">
          <circle
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            cx="12"
            cy="12"
            r="3"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
          />
        </symbol>

        <symbol id="icon-person" viewBox="0 0 16 16">
          <circle
            cx="8"
            cy="5.5"
            r="2.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            d="M2.5 14 c 0 -2.8 2.5 -4.5 5.5 -4.5 s 5.5 1.7 5.5 4.5"
          />
        </symbol>
        <symbol id="icon-book" viewBox="0 0 16 16">
          <rect
            x="2"
            y="3"
            width="12"
            height="10"
            rx="1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <line
            x1="2"
            y1="6"
            x2="14"
            y2="6"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <line
            x1="5"
            y1="9"
            x2="11"
            y2="9"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="icon-home" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M2 8 L8 3 L14 8 V14 a1 1 0 0 1 -1 1 H10 V10 H6 V15 H3 a1 1 0 0 1 -1 -1 Z"
          />
        </symbol>
        <symbol id="icon-refer" viewBox="0 0 24 24">
          <circle
            cx="9"
            cy="8"
            r="3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <path
            d="M3 19 c 0 -3.5 3 -6 6 -6 s 6 2.5 6 6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path
            d="M16 6 L20 10 L16 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="20"
            y1="10"
            x2="14"
            y2="10"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="icon-shield" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M8 2 L13 4 V8 c 0 3 -2 5 -5 6 c -3 -1 -5 -3 -5 -6 V 4 Z"
          />
          <path
            d="M6 8 L7.5 9.5 L10 7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="icon-signout" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.5 3 H4 a1 1 0 0 0 -1 1 v8 a1 1 0 0 0 1 1 h5.5 M11 5.5 L13.5 8 L11 10.5 M7 8 H13.5"
          />
        </symbol>
        <symbol id="icon-card" viewBox="0 0 24 24">
          <rect
            x="2"
            y="5"
            width="20"
            height="14"
            rx="2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          ></rect>
          <line
            x1="2"
            y1="9"
            x2="22"
            y2="9"
            stroke="currentColor"
            strokeWidth="1.5"
          ></line>
          <line
            x1="5"
            y1="14"
            x2="9"
            y2="14"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          ></line>
        </symbol>
        <symbol id="icon-gift" viewBox="0 0 16 16">
          <rect
            x="2"
            y="7"
            width="12"
            height="7"
            rx="1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            x="1"
            y="5"
            width="14"
            height="3"
            rx=".8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <line
            x1="8"
            y1="5"
            x2="8"
            y2="14"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M5 4 a 2 2 0 0 1 3 -1 a 2 2 0 0 1 3 1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="icon-receipt" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M3 2 H13 V15 L11 13.5 L9 15 L7 13.5 L5 15 L3 13.5 Z"
          />
          <line
            x1="5"
            y1="6"
            x2="11"
            y2="6"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
          <line
            x1="5"
            y1="9"
            x2="11"
            y2="9"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
          <line
            x1="5"
            y1="11.5"
            x2="8"
            y2="11.5"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="icon-mail" viewBox="0 0 16 16">
          <rect
            x="2"
            y="4"
            width="12"
            height="9"
            rx="1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M2 5 L8 9 L14 5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="icon-cert-gold" viewBox="0 0 48 56">
          <rect
            x="6"
            y="2"
            width="36"
            height="32"
            rx="3"
            fill="#F5B041"
            fillOpacity=".15"
            stroke="#C4841D"
            strokeWidth="2.5"
            strokeLinejoin="round"
          />
          <rect x="14" y="8" width="20" height="6" rx="1.5" fill="#C4841D" />
          <line
            x1="12"
            y1="20"
            x2="36"
            y2="20"
            stroke="#C4841D"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="16"
            y1="26"
            x2="32"
            y2="26"
            stroke="#C4841D"
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity=".5"
          />
          <path
            d="M18 46l-4 9 3-1.5 1.5 3 3-8"
            fill="#C4841D"
            fillOpacity=".6"
            stroke="#C4841D"
            strokeWidth="1"
            strokeLinejoin="round"
          />
          <path
            d="M30 46l4 9-3-1.5-1.5 3-3-8"
            fill="#C4841D"
            fillOpacity=".6"
            stroke="#C4841D"
            strokeWidth="1"
            strokeLinejoin="round"
          />
          <circle cx="24" cy="40" r="11" fill="#FAFAFE" />
          <circle
            cx="24"
            cy="40"
            r="9"
            fill="#F5B041"
            fillOpacity=".25"
            stroke="#C4841D"
            strokeWidth="2.5"
          />
          <circle
            cx="24"
            cy="40"
            r="5.5"
            fill="none"
            stroke="#C4841D"
            strokeWidth="1.5"
          />
          <path
            d="M21 40l2 2 4-4"
            fill="none"
            stroke="#C4841D"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
        <symbol id="icon-lock" viewBox="0 0 16 16">
          <rect
            x="3"
            y="7"
            width="10"
            height="7"
            rx="1.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            d="M5.5 7 V5 a2.5 2.5 0 0 1 5 0 V7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
        </symbol>
        <symbol id="icon-locked-padlock" viewBox="0 0 16 16">
          <rect
            x="3"
            y="7"
            width="10"
            height="7"
            rx="1.5"
            fill="currentColor"
            opacity=".9"
          />
          <path
            d="M5.5 7 V5 a2.5 2.5 0 0 1 5 0 V7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </symbol>
        <symbol id="icon-danger" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M8 1 L15 14 L1 14 Z"
          />
          <line
            x1="8"
            y1="6"
            x2="8"
            y2="10"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <circle cx="8" cy="12" r=".8" fill="currentColor" />
        </symbol>
        <symbol id="icon-sparkle" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
          />
        </symbol>
        <symbol id="icon-camera" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
            d="M2 5 H4.5 L5.5 3.5 H10.5 L11.5 5 H14 V13 a1 1 0 0 1 -1 1 H3 a1 1 0 0 1 -1 -1 Z"
          />
          <circle
            cx="8"
            cy="9"
            r="2.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </symbol>
        <symbol id="icon-download" viewBox="0 0 14 14">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7 2 V9 M4 7 L7 10 L10 7 M2 12 H12"
          />
        </symbol>
        <symbol id="icon-chevron-l" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10 3 L5 8 L10 13"
          />
        </symbol>
        <symbol id="icon-chevron-r" viewBox="0 0 16 16">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 3 L11 8 L6 13"
          />
        </symbol>
        <symbol id="icon-close" viewBox="0 0 14 14">
          <line
            x1="2"
            y1="2"
            x2="12"
            y2="12"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <line
            x1="12"
            y1="2"
            x2="2"
            y2="12"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="icon-arrow-up" viewBox="0 0 12 12">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 10 V2 M3 5 L6 2 L9 5"
          />
        </symbol>

        <symbol id="ln-rank" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 4 V21 M6 4 L18 4 L15.5 9 L18 14 L6 14"
          />
        </symbol>
        <symbol id="ln-badge" viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="9"
            r="6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 14 L7.5 21 L12 18.5 L16.5 21 L15 14"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6 L13 8 L15 8.2 L13.5 9.6 L14 11.6 L12 10.5 L10 11.6 L10.5 9.6 L9 8.2 L11 8 Z"
          />
        </symbol>
        <symbol id="ln-cert" viewBox="0 0 24 24">
          <rect
            x="3"
            y="3.5"
            width="18"
            height="11.5"
            rx="1.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <line
            x1="6.5"
            y1="7"
            x2="17.5"
            y2="7"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
          <line
            x1="6.5"
            y1="10"
            x2="13"
            y2="10"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
          <circle
            cx="12"
            cy="18.5"
            r="3.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.4 20.7 L9.5 24 L12 22.4 L14.5 24 L13.6 20.7"
          />
        </symbol>
        <symbol id="ln-crown" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M3 8 L7 13 L12 6 L17 13 L21 8 L19 19 H5 Z"
          />
          <line
            x1="5"
            y1="19"
            x2="19"
            y2="19"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="ln-star" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M12 3 L14.6 9 L21 9.5 L16 13.8 L17.6 20 L12 16.5 L6.4 20 L8 13.8 L3 9.5 L9.4 9 Z"
          />
        </symbol>
        <symbol id="ln-bulb" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 3 a6 6 0 0 0 -4 10.5 V16 h8 v-2.5 A6 6 0 0 0 12 3 Z"
          />
          <line
            x1="9.5"
            y1="19"
            x2="14.5"
            y2="19"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
          <line
            x1="10.5"
            y1="21.5"
            x2="13.5"
            y2="21.5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </symbol>
        <symbol id="ln-community" viewBox="0 0 24 24">
          <circle
            cx="8.5"
            cy="9"
            r="3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <circle
            cx="16"
            cy="10"
            r="2.4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            d="M3.5 19 c 0 -3 2.2 -5 5 -5 s 5 2 5 5"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            d="M15 14.2 c 2.3 0 4 1.7 4 4.3"
          />
        </symbol>
        <symbol id="ln-book" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M12 6 C 10 4.5 7 4 4 4.5 V18.5 C 7 18 10 18.5 12 20 C 14 18.5 17 18 20 18.5 V4.5 C 17 4 14 4.5 12 6 Z"
          />
          <line
            x1="12"
            y1="6"
            x2="12"
            y2="20"
            stroke="currentColor"
            strokeWidth="1.6"
          />
        </symbol>
        <symbol id="ln-camera" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
            d="M3 8 H6 L7.5 5.5 H16.5 L18 8 H21 V19 a1 1 0 0 1 -1 1 H4 a1 1 0 0 1 -1 -1 Z"
          />
          <circle
            cx="12"
            cy="13"
            r="3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
          />
        </symbol>
        <symbol id="ln-gift" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M4 9 H20 V20 a1 1 0 0 1 -1 1 H5 a1 1 0 0 1 -1 -1 Z M3 6 a1 1 0 0 1 1 -1 H20 a1 1 0 0 1 1 1 V9 H3 Z M12 5 V21 M8.5 5 C 7 2.5 10 1 12 4 C 14 1 17 2.5 15.5 5 H8.5 Z"
          />
        </symbol>
        <symbol id="ln-brain" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 5 a3 3 0 0 0 -5.5 1.6 a3 3 0 0 0 -1.5 5 a3 3 0 0 0 2 4.6 a2.6 2.6 0 0 0 5 .3 Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 5 a3 3 0 0 1 5.5 1.6 a3 3 0 0 1 1.5 5 a3 3 0 0 1 -2 4.6 a2.6 2.6 0 0 1 -5 .3 Z"
          />
        </symbol>
        <symbol id="ln-target" viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <circle
            cx="12"
            cy="12"
            r="4.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <circle cx="12" cy="12" r="1.4" fill="currentColor" />
        </symbol>

        <symbol id="icon-linkedin" viewBox="0 0 24 24">
          <path
            fill="#0A66C2"
            d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 1 1 8.3 6.5 1.75 1.75 0 0 1 6.5 8.25zM19 19h-3v-4.74c0-1.42-.6-2.26-1.84-2.26A2 2 0 0 0 12.32 13a3 3 0 0 0-.14 1V19h-3v-9h2.9v1.3a3.11 3.11 0 0 1 2.7-1.4c1.55 0 3.36.86 3.36 3.66z"
          />
        </symbol>
        <symbol id="icon-google" viewBox="0 0 24 24">
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09a6.6 6.6 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 12 1a11 11 0 0 0-9.82 6.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
          />
        </symbol>
        <symbol id="icon-facebook" viewBox="0 0 24 24">
          <path
            fill="#1877F2"
            d="M24 12a12 12 0 1 0-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3 1.79-4.67 4.53-4.67 1.31 0 2.69.24 2.69.24v2.95h-1.51c-1.49 0-1.96.93-1.96 1.88V12h3.33l-.53 3.47h-2.8v8.38A12 12 0 0 0 24 12z"
          />
        </symbol>
        <symbol id="icon-apple" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M17.05 12.04c-.02-2.16 1.76-3.2 1.84-3.25-1.01-1.48-2.58-1.68-3.13-1.7-1.33-.13-2.6.78-3.28.78-.68 0-1.72-.76-2.83-.74-1.45.02-2.8.85-3.55 2.15-1.51 2.63-.39 6.51 1.09 8.65.72 1.05 1.58 2.22 2.7 2.18 1.09-.04 1.5-.7 2.81-.7s1.69.7 2.83.68c1.17-.02 1.91-1.06 2.62-2.11.83-1.21 1.17-2.4 1.19-2.46-.03-.01-2.28-.87-2.3-3.48zM14.74 5.5c.6-.73 1.01-1.74.9-2.75-.87.04-1.93.58-2.55 1.3-.56.64-1.05 1.67-.92 2.66.97.08 1.96-.49 2.57-1.21z"
          />
        </symbol>

        <symbol id="empty-state-art" viewBox="0 0 200 160">
          <use
            href="#blob-1"
            fill="#F3EC7A"
            transform="translate(100 80) scale(.8)"
            opacity=".5"
          />
          <use
            href="#blob-2"
            fill="#B798F2"
            transform="translate(120 90) scale(.5)"
            opacity=".4"
          />
          <g transform="translate(40 40)">
            <rect
              x="0"
              y="0"
              width="120"
              height="80"
              rx="6"
              fill="#fff"
              stroke="#2E2437"
              strokeWidth="2.5"
            />
            <rect x="10" y="10" width="100" height="50" rx="3" fill="#E8EBFF" />
            <rect
              x="14"
              y="18"
              width="60"
              height="6"
              rx="2"
              fill="#233dff"
              opacity=".6"
            />
            <rect
              x="14"
              y="30"
              width="80"
              height="4"
              rx="2"
              fill="#2E2437"
              opacity=".25"
            />
            <rect
              x="14"
              y="40"
              width="70"
              height="4"
              rx="2"
              fill="#2E2437"
              opacity=".25"
            />
            <rect
              x="14"
              y="50"
              width="40"
              height="4"
              rx="2"
              fill="#2E2437"
              opacity=".25"
            />
            <circle
              cx="100"
              cy="70"
              r="10"
              fill="#F5B041"
              stroke="#2E2437"
              strokeWidth="2"
            />
            <path
              d="M96 70 L100 74 L106 67"
              fill="none"
              stroke="#2E2437"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </symbol>
      </defs>
    </svg>
  );
};

export default Icons;
